import { lazy } from 'react';

const StudentDemoAccountModal = lazy(() =>
  import('./components/StudentDemoAccountModal.js'),
);

export default {
  STUDENT_DEMO_ACCOUNT: StudentDemoAccountModal,
};
